import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { DialogExpirationComponent } from './dialog-expiration.component';

@NgModule({
  declarations: [DialogExpirationComponent],
  exports: [DialogExpirationComponent],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class DialogExpirationModule {}
